export const styles = {
  container: {
    padding: 2,
    paddingBottom: 10,
    maxWidth: '800px',
    margin: '0 auto',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
  },
  title: {
    marginBottom: 3,
    textAlign: 'center' as const,
    fontFamily: "'Caveat', cursive",
    fontSize: '2rem',
  },
  listPaper: {
    padding: 2,
    paddingRight: 1,
    backgroundColor: '#ffffd7',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    minHeight: '300px',
    fontFamily: "'Caveat', cursive",
    marginBottom: 10
  },
  emptyText: {
    textAlign: 'center' as const,
    padding: 4,
    fontFamily: "'Caveat', cursive",
    fontSize: '1.2rem',
  },
  categorySection: {
    marginBottom: 3,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  categoryTitle: {
    fontSize: '1.6rem',
    fontWeight: 600,
    color: 'primary.main',
    marginBottom: 0,
    paddingBottom: 0.5,
    fontFamily: "'Caveat', cursive",
  },
  productItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 0,
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
  },
  productInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
  },
  productName: {
    fontWeight: 500,
    fontSize: '1.4rem',
    fontFamily: "'Caveat', cursive",
  },
  productComment: {
    fontFamily: "'Caveat', cursive",
    lineHeight: 1,
    fontSize: '1.2rem',
  },
  actionButtons: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center',
  },
  blockButton: {
    color: 'warning.main',
    '&:hover': {
      backgroundColor: 'warning.light',
    },
  },
  deleteButton: {
    color: 'error.main',
    '&:hover': {
      backgroundColor: 'error.light',
    },
  },
  editButton: {
    color: 'info.main',
    '&:hover': {
      backgroundColor: 'info.light',
    },
  },
  addButtonContainer: {
    position: 'fixed' as const,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 1,
    backgroundColor: 'background.paper',
    borderTop: '1px solid',
    borderColor: 'divider',
    zIndex: 1000,
  },
  addButton: {
    paddingY: 1.0,
    fontSize: '0.8em',
  },
};